// src/components/notifications/GlobalNotificationArea.js
import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { NotificationContext } from '../../context/NotificationContext';
import Notification from './Notification'; // Your existing Notification component
import './GlobalNotificationArea.css'; // Styling for the container

const GlobalNotificationArea = () => {
  const { notifications, dismissNotification, clearAllNotifications } = useContext(NotificationContext);
  const location = useLocation();

  useEffect(() => {
    // This effect runs when the user navigates to a new page,
    // clearing any notifications from the previous page.
    clearAllNotifications();
  }, [location.pathname, clearAllNotifications]);

  const persistentNotifications = notifications.filter((n) => n.isPersistent);
  const nonPersistentNotifications = notifications.filter((n) => !n.isPersistent);

  if (notifications.length === 0) {
    return null;
  }

  return (
    <>
      {/* Area for persistent notifications */}
      <div className="global-notification-area persistent">
        {persistentNotifications.map((notif) => (
          <Notification key={notif.id} message={notif.message} type={notif.type} duration={notif.duration} isPersistent={notif.isPersistent} actions={notif.actions} onClose={() => dismissNotification(notif.id)} />
        ))}
      </div>
      {/* Area for non-persistent notifications */}
      <div className="global-notification-area non-persistent">
        {nonPersistentNotifications.map((notif) => (
          <Notification key={notif.id} message={notif.message} type={notif.type} duration={notif.duration} isPersistent={notif.isPersistent} actions={notif.actions} onClose={() => dismissNotification(notif.id)} />
        ))}
      </div>
    </>
  );
};

export default GlobalNotificationArea;
